"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentShipmentProductResponse = exports.mockedFulfillmentShipmentProductCreateRequest = void 0;
const fulfillment_product_1 = require("../fulfillment-product");
exports.mockedFulfillmentShipmentProductCreateRequest = {
  fulfillmentProductId: 1,
  quantity: 1
};
exports.mockedFulfillmentShipmentProductResponse = {
  id: 1,
  fulfillmentProduct: fulfillment_product_1.mockedFulfillmentProductResponse,
  quantity: 1
};